import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WorkProjectLinks from './WorkProjectLinks';
import { useActiveSection } from './useActiveSection';

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
}

const WorkSideNav = ({ sections, slidesLink, videoHref, figmaLink }) => {
  const sectionIds = useMemo(() => sections.map((s) => s.id), [sections]);
  const activeId = useActiveSection(sectionIds);

  const hasProjectLinks = Boolean(slidesLink || videoHref || figmaLink);
  const hasContents = sections.length > 0;

  if (!hasContents && !hasProjectLinks) {
    return null;
  }

  return (
    <aside className="work-layout__aside" aria-label="Case study navigation">
      {hasContents && (
        <nav className="work-side-nav__toc" aria-label="On this page">
          <p className="work-side-nav__label">Contents</p>
          <ul className="work-side-nav__list">
            {sections.map(({ id, label }) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className={classNames('work-side-nav__link', { 'is-active': activeId === id })}
                  aria-current={activeId === id ? 'location' : undefined}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(id);
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}

      {hasProjectLinks && (
        <WorkProjectLinks
          slidesLink={slidesLink}
          videoHref={videoHref}
          figmaLink={figmaLink}
          className="work-side-nav__project"
        />
      )}
    </aside>
  );
};

WorkSideNav.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  slidesLink: PropTypes.string,
  videoHref: PropTypes.string,
  figmaLink: PropTypes.string
};

WorkSideNav.defaultProps = {
  sections: [],
  slidesLink: '',
  videoHref: '',
  figmaLink: ''
};

export default WorkSideNav;
